<template>
  <div class="goods-page">
    <top-bar :topbarList="goodsTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";
import { mapState } from "vuex";

import { goodsIndexMixins } from "@/mixins/goodsIndexMixins";

export default {
  mixins: [goodsIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.goods-page {
  height: 100%;
}
</style>
